import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import bin from "../assets/images/logout.svg";
import { apiCall } from "../services/AxiosService";
import { API_URL } from "../services/APIRoute";
import { apiResponse } from "../services/APIResponse";
import { Spinner } from "react-bootstrap";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";

function LogoutModal(props) {
  const [Loading, setLoading] = useState(false);
 

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="delete-modal"
    >
      {Loading && <MainpageLoader/>}
      <Modal.Body>
        <div className="text-center">
          <img src={bin} alt="bin" className="modal-delete-icon" />
          <h4>Are you sure you want to logout ?</h4>
          {/* <p>Please confirm if you wish to proceed with deleting this item.</p> */}
          <div className="d-flex align-items-center gap-2">
            <button className="grey-btn" onClick={props.onHide}>
              No
            </button>
            <button className="red-btn" onClick={(e) => props.bindlist()}>
              {Loading ? (
                // <>
                //   <span>Loading</span>{" "}
                //   <Spinner
                //     className="ms-1"
                //     animation="border"
                //     role="status"
                //     size="sm"
                //   >
                //     <span className="visually-hidden">Loading...</span>
                //   </Spinner>
                // </>
                <SubmitLoading />
              ) : (
                " Yes"
              )}
            </button>
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
}

export default LogoutModal;
